import { useState } from 'react';
import type { FormEvent } from 'react';
import { useTranslation } from 'react-i18next';
import { HiMagnifyingGlass } from 'react-icons/hi2';
import {
  SearchBarWrapper,
  SearchIconWrapper,
  SearchInput,
  SubmitButton,
} from './SearchBar.styled';

interface SearchBarProps {
  onSearch: (query: string) => void;
  isSearching: boolean;
  initialQuery?: string;
}

export default function SearchBar({ onSearch, isSearching, initialQuery = '' }: SearchBarProps) {
  const { t } = useTranslation();
  const [query, setQuery] = useState(initialQuery);

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();
    const trimmed = query.trim();
    if (trimmed) {
      onSearch(trimmed);
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <SearchBarWrapper>
        <SearchIconWrapper>
          <HiMagnifyingGlass />
        </SearchIconWrapper>
        <SearchInput
          type="text"
          placeholder={t('search.placeholder')}
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          disabled={isSearching}
        />
        <SubmitButton type="submit" disabled={isSearching || !query.trim()}>
          {isSearching ? t('search.searching') : t('search.button')}
        </SubmitButton>
      </SearchBarWrapper>
    </form>
  );
}
